// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import colors from 'vuetify/util/colors'

// Locale
import { el, en } from 'vuetify/locale'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: colors.grey.darken3,
          secondary: colors.grey.lighten2
        }
      }
    }
  },
  locale: {
    locale: 'el',
    fallback: 'en',
    messages: { el, en }
  }
})
